var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18C16.55 18 17.025 17.8083 17.425 17.425C17.8083 17.025 18 16.55 18 16L18 2C18 1.45 17.8083 0.983334 17.425 0.600001C17.025 0.2 16.55 0 16 0L2 0C1.45 0 0.983332 0.2 0.599998 0.600001C0.199997 0.983334 -1.90735e-06 1.45 -1.90735e-06 2L-1.90735e-06 16C-1.90735e-06 16.55 0.199997 17.025 0.599998 17.425C0.983332 17.8083 1.45 18 2 18L16 18ZM16 16L2 16L2 2L16 2L16 16ZM15 14L3 14L6.75 9L9.75 13L12 10L15 14ZM16 16L16 2L16 16Z",
    fill: "#1D1B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSmall);
export default __webpack_public_path__ + "static/media/imageSmall.d259f533a55c6ec18e459f9a9015be44.svg";
export { ForwardRef as ReactComponent };